import _ from 'lodash';

export const PHONE_TYPE = {
    MOBILE: 'MOBILE',
    HOME: 'HOME'
};

export function getPhoneTypeOptions(intl, localePrefix) {
    return [{
        id: PHONE_TYPE.MOBILE,
        displayText: intl.formatMessage({ id: `${localePrefix}.phonetype-mobile` })
    }, {
        id: PHONE_TYPE.HOME,
        displayText: intl.formatMessage({ id: `${localePrefix}.phonetype-home` })
    }];
}

//Validating the phone number
export const isValidPhoneNumber = (griffinHandler, msg) => (value, previousValue, allValues) => {

    if (_.get(allValues, 'values.phoneOptOut', false)) {
        return;
    }

    const normalizedPhoneNumber = griffinHandler.normalizePhoneNumber(value);

    if (_.get(normalizedPhoneNumber, 'errors')) {
        return {
            msg,
            className: 'hasError'
        };
    } else {
        return;
    }
};

export const isTelephoneEmpty = (msg) => (value, previousValue, allValues) => {

    if (_.get(allValues, 'values.phoneOptOut', false)) {
        return;
    }

    if (typeof value === 'undefined' || value === null || value === '') {
        return {
            msg,
            className: 'hasError'
        };
    }
};



export const formatPhoneNumber = (griffinPhoneHandler, phoneString) => {
    try {
        const phoneObj = griffinPhoneHandler.normalizePhoneNumber(phoneString);
        if (_.get(phoneObj, 'errors')) {
            return phoneString;
        }

        let formattedPhoneNumber = griffinPhoneHandler.formatPhoneNumber(
            phoneObj,
            { style: griffinPhoneHandler.PHONENUMBER_FORMAT_INTERNATIONAL }
        );
        if (_.get(formattedPhoneNumber, 'errors')) {
            return phoneString;
        }

        formattedPhoneNumber = formattedPhoneNumber.split(' ')[1];
        return formattedPhoneNumber;
    } catch (e) {
        capeLog && capeLog(`formatPhoneNumber error: ${e}`);
        return phoneString;
    }
};
